import { render, staticRenderFns } from "./SelectExchangeProduct.vue?vue&type=template&id=31af047d&scoped=true&"
import script from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
export * from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectExchangeProduct.vue?vue&type=style&index=0&id=31af047d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af047d",
  null
  
)

export default component.exports